import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AuthModel, AuthPayload } from '../../models/auth.model';
import { UserModel } from '../../models/user.model';
import { RootState } from '..';

// identifier
export const AUTH_SLICE_ID = 'auth';

// default state
const initialState: AuthModel = {
  isSigningOut: false,
  isAuthenticated: false,
  accessToken: '',
  user: {},
};

//slice
const authSlice = createSlice({
  name: AUTH_SLICE_ID,
  initialState,
  reducers: {
    login: (state: AuthModel, action: PayloadAction<AuthPayload>) => {
      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
    },
    setUser: (state: AuthModel, action: PayloadAction<UserModel>) => {
      state.user = action.payload;
    },
    logout: (state: AuthModel) => {
      state.accessToken = '';
      state.isAuthenticated = false;
      state.user = {};
    },
    setIsSigningOut: (state: AuthModel, action: PayloadAction<boolean>) => {
      state.isSigningOut = action.payload;
    },
  },
});

//selectors
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectAccessToken = (state: RootState) => state.auth.accessToken;
export const selectIsSigningOut = (state: RootState) => state.auth.isSigningOut;

//actions
export const { login, logout, setUser, setIsSigningOut } = authSlice.actions;

//reducer
export default authSlice;
